import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { Tc } from '../../../core/_infrastructure/types/common';
import { RegLaboratorioViewModel, RegTecnicoLaboratorioViewModel } from './laboratorio.types';
import { RegLaboratorioService } from './laboratorio.service';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-laboratorio-edit',
    templateUrl: './laboratorio-edit.component.html',
})
export class LaboratorioEditComponent extends ComponentBase implements OnInit {
    editTitle = 'Nuevo';
    editMode: boolean;
    listComunidad: Tc[];
    listProvincia: Tc[];
    listMunicipio: Tc[];
    laboratorio: RegLaboratorioViewModel;
    visibilitySpinner = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificationService: NotificationService,
        private laboratorioService: RegLaboratorioService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
        this.laboratorio = new RegLaboratorioViewModel();
    }

    ngOnInit() {
        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.laboratorioService.getLaboratorio(id).subscribe(result => {
                this.laboratorio = result;
                this.updateForm();
            });
        }

        this.globalService.getComunidadesAutonomas().subscribe(params => {
            this.listComunidad = params;
        });
        //this.listProvincia$ = this.globalService.getProvincias();
    }

    createForm() {
        this.form = this.fb.group({
            RazonSocial: ['', Validators.required],
            Direccion: ['', Validators.required],
            CodigoPostal: ['', Validators.required],
            IdComunidadAutonoma: [null, Validators.required],
            IdProvincia: [null, Validators.required],
            IdMunicipio: [null, Validators.required],
            NombrePersonaContacto: '',
            ApellidosPersonaContacto: '',
            EmailPersonaContacto: ['', Validators.compose([Validators.required, CustomValidator.emailEmptyValidator])],
            TelefonoPersonaContacto: '',
            Activo: [true, Validators.required],
            Observaciones: '',
        });
    }

    updateForm() {
        this.form.setValue({
            RazonSocial: this.laboratorio.RazonSocial || '',
            Direccion: this.laboratorio.Direccion || '',
            CodigoPostal: this.laboratorio.CodigoPostal || '',
            IdComunidadAutonoma: this.laboratorio.IdComunidadAutonoma || null,
            IdProvincia: this.laboratorio.IdProvincia || null,
            IdMunicipio: this.laboratorio.IdMunicipio || null,
            NombrePersonaContacto: this.laboratorio.NombrePersonaContacto || '',
            ApellidosPersonaContacto: this.laboratorio.ApellidosPersonaContacto || '',
            EmailPersonaContacto: this.laboratorio.EmailPersonaContacto || '',
            TelefonoPersonaContacto: this.laboratorio.TelefonoPersonaContacto || '',
            Activo: this.laboratorio.Activo || false,
            Observaciones: this.laboratorio.Observaciones || '',
        });

        const idCA = this.form.value.IdComunidadAutonoma;
        const idProvincia = this.form.value.IdProvincia;

        this.globalService.getProvinciasByComunidad(idCA).subscribe(params => {
            this.listProvincia = params;
        });
        this.globalService.getMunicipios(idProvincia).subscribe(params => {
            this.listMunicipio = params;
        });
    }

    onSelectComunidad() {
        const idCA = this.form.value.IdComunidadAutonoma;

        this.globalService.getProvinciasByComunidad(idCA).subscribe(params => {
            this.listProvincia = params;
        });

        this.form.patchValue({
            IdProvincia: null,
            IdMunicipio: null,
        });
    }

    onSelectProvincia() {
        const idProvincia = this.form.value.IdProvincia;

        this.globalService.getMunicipios(idProvincia).subscribe(params => {
            this.listMunicipio = params;
        });

        this.form.patchValue({
            IdMunicipio: null,
        });
    }

    onSave() {
        //si se desactiva el Laboratorio mostrar mensaje de confirmación
        if (!this.form.value.Activo) {
            this.confirmationService.confirm({
                message: 'Si desactiva el Laboratorio, se desactivarán sus técnicos asociados, ¿quiere continuar?',
                accept: () => {
                    //Actual logic to perform a confirmation
                    this.onSubmit();
                },
            });
        } else {
            this.onSubmit();
        }
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            return;
        }

        this.visibilitySpinner = true;

        let laboratorio = new RegLaboratorioViewModel();

        laboratorio.RazonSocial = this.form.value.RazonSocial;
        laboratorio.Direccion = this.form.value.Direccion;
        laboratorio.CodigoPostal = this.form.value.CodigoPostal;
        laboratorio.IdComunidadAutonoma = this.form.value.IdComunidadAutonoma;
        laboratorio.IdProvincia = this.form.value.IdProvincia;
        laboratorio.IdMunicipio = this.form.value.IdMunicipio;
        laboratorio.NombrePersonaContacto = this.form.value.NombrePersonaContacto;
        laboratorio.ApellidosPersonaContacto = this.form.value.ApellidosPersonaContacto;
        laboratorio.EmailPersonaContacto = this.form.value.EmailPersonaContacto;
        laboratorio.TelefonoPersonaContacto = this.form.value.TelefonoPersonaContacto;
        laboratorio.Activo = this.form.value.Activo;
        laboratorio.Observaciones = this.form.value.Observaciones;

        laboratorio.Id = this.laboratorio.Id;

        if (this.editMode) {
            this.laboratorioService.editLaboratorio(laboratorio).subscribe({
                next: () => {
                    this.addSuccessMessage('Laboratorio modificado correctamente');
                    this.visibilitySpinner = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.laboratorioService.createLaboratorio(laboratorio).subscribe({
                next: () => {
                    this.addSuccessMessage('Laboratorio añadido correctamente');
                    this.visibilitySpinner = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onAddTecnico() {
        this.router.navigate([this.router.url, 'tecnicos', 'create']);
    }

    onEditTecnico(item: RegTecnicoLaboratorioViewModel) {
        this.router.navigate([this.router.url, 'tecnicos', 'edit', item.IdUsuario]);
    }

    onBack() {
        this.router.navigate(['/mantenimiento/registros/laboratorios']);
    }
}
